<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-row v-if="tab == 0">
          <v-card class="" width="500px">
            <v-app-bar dark color="primary">
              <v-toolbar-title>Ingresar</v-toolbar-title>
            </v-app-bar>
            <v-card-text>
              <v-text-field
                label="DNI"
                v-model="dni"
                prepend-icon="mdi-card-account-details-outline"
                type="number"
              ></v-text-field>
              <v-text-field
                @keydown.enter.prevent="login"
                label="CONTRASEÑA"
                v-model="contrasena"
                prepend-icon="mdi-key"
                :type="showpass ? 'text' : 'password'"
                :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showpass = !showpass"
              ></v-text-field>
              <div class="text-center">
                <v-btn text small color="blue" @click="tab = 2">
                  Olvidaste tu contraseña?
                </v-btn>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="login" color="fondomenu" dark>Ingresar</v-btn>
            </v-card-actions>
            <v-col class="text-center pt-5">
              Todavia no tengo una cuenta
              <v-btn text small @click="tab = 1" color="green" dark
                >Registrarme</v-btn
              >
            </v-col>
          </v-card>
        </v-row>
        <v-row v-if="tab == 1">
          <v-card width="500px">
            <v-app-bar dark color="primary">
              <v-toolbar-title>Registro</v-toolbar-title>
            </v-app-bar>
            <v-card-text>
              <h4 v-if="!cambiarcontrasena">
                Ingrese su DNI y Fecha de Nacimiento
              </h4>
              <v-row v-if="!cambiarcontrasena">
                <v-col md="6">
                  <v-text-field
                    :disabled="beneficiarioregistro != null"
                    label="DNI"
                    v-model="dni"
                    prepend-icon="mdi-card-account-details-outline"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col md="6">
                  <v-text-field
                    :disabled="beneficiarioregistro != null"
                    @keydown.enter.prevent="validar"
                    label="Fecha de Nacimiento"
                    type="date"
                    v-model="fec_nac"
                    prepend-icon="mdi-cake-variant"
                  ></v-text-field>
                </v-col>
              </v-row>
              <h2 v-if="cambiarcontrasena">Cambie su contraseña</h2>
              <v-row v-if="beneficiarioregistro">
                <v-col md="12" class="text-center">
                  <h2 class="green--text text-decoration-underline">
                    {{ beneficiarioregistro.apellido_y_nombre }}
                  </h2>
                </v-col>
                <v-col md="12">
                  <v-text-field
                    label="Mail de contacto"
                    v-model="beneficiarioregistro.mail"
                    prepend-icon="mdi-at"
                  ></v-text-field>
                  <v-text-field
                    label="Telefono (solo numeros, sin 0 ni 15)"
                    v-model="beneficiarioregistro.telefono"
                    prepend-icon="mdi-phone"
                    type="tel"
                    v-mask="'##########'"
                  ></v-text-field>
                  <v-text-field
                    label="Contraseña"
                    v-model="contrasenaalta"
                    prepend-icon="mdi-lock"
                    :type="showpassalta ? 'text' : 'password'"
                    :append-icon="showpassalta ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showpassalta = !showpassalta"
                  ></v-text-field>
                  <v-text-field
                    label="Repita Contraseña"
                    v-model="contrasenaaltarepita"
                    prepend-icon="mdi-lock"
                    :type="showpassaltarepita ? 'text' : 'password'"
                    :append-icon="
                      showpassaltarepita ? 'mdi-eye' : 'mdi-eye-off'
                    "
                    @click:append="showpassaltarepita = !showpassaltarepita"
                  ></v-text-field>
                </v-col>
                <h4 class="red--text">{{ observaciones }}</h4>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                @click="validar"
                v-if="beneficiarioregistro == null"
                color="fondomenu"
                dark
                >Validar</v-btn
              >
              <v-btn
                :disabled="!valida"
                @click="aceptaralta"
                v-if="beneficiarioregistro != null"
                color="green"
                >Aceptar
              </v-btn>
              <v-btn
                @click="beneficiarioregistro = null"
                v-if="beneficiarioregistro != null"
                color="red"
                >Cancelar
              </v-btn>
            </v-card-actions>
            <v-col class="text-center pt-5">
              <v-btn @click="tab = 0" color="red" text small
                >Ya tengo una cuenta</v-btn
              >
            </v-col>
          </v-card>
        </v-row>
        <v-row v-if="tab == 2">
          <v-card width="500px">
            <v-app-bar dark color="primary">
              <v-toolbar-title>Recuperar contraseña</v-toolbar-title>
            </v-app-bar>
            <v-card-text>
              <v-text-field
                label="Ingrese su mail"
                v-model="mailrecuperar"
                prepend-icon="mdi-email"
                type="mail"
              >
              </v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="recuperarcontrasena" color="fondomenu" dark
                >Aceptar</v-btn
              >
            </v-card-actions>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="tab = 0" class="ml-3" color="green" dark
                >Cancelar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import API from "@/lib/API";
import LUM from "@/lib/LUM";
import { mask } from "vue-the-mask";
export default {
  directives: { mask },
  data() {
    return {
      mailrecuperar: "",
      dni: "",
      contrasena: "",
      tab: 0,
      fec_nac: "",
      beneficiarioregistro: null,
      contrasenaalta: "",
      contrasenaaltarepita: "",
      valida: false,
      showpass: false,
      showpassalta: false,
      showpassaltarepita: false,
      cambiarcontrasena: false,
    };
  },
  computed: {
    ...mapState("autogestion", ["Usuario"]),
    observaciones() {
      this.valida = true;
      let obs = "";
      if (this.beneficiarioregistro.mail == "") {
        obs += " * ingrese un mail";
      }
      if (!LUM.validateEmail(this.beneficiarioregistro.mail)) {
        obs += " * email incorrecto";
      }
      if (this.beneficiarioregistro.telefono.length != 10) {
        obs += " * Telefono incorrecto";
      }

      if (this.contrasenaalta !== this.contrasenaaltarepita) {
        obs += " * no coinciden las contraseñas";
      }
      if (this.contrasenaalta == "") {
        obs += " * ingrese la contraseña";
      } else {
        if (this.contrasenaalta.length < 6) {
          obs += " * minimo 6 caracteres";
        }
      }

      if (obs) {
        this.valida = false;
      }

      return obs;
    },
  },
  methods: {
    ...mapActions(["cargarData"]),
    ...mapActions("comun", ["inicializar", "traerUserId"]),
    ...mapActions("autogestion", ["loguear", "logout"]),
    ...mapActions("beneficiarios", ["setNuevo", "selectTitular", "select"]),
    resetear() {
      this.dni = "";
      this.contrasena = "";
      this.tab = null;
      this.fec_nac = "";
      this.beneficiarioregistro = null;
      this.contrasenaalta = "";
      this.contrasenaaltarepita = "";
      this.valida = false;
      this.showpass = false;
      this.showpassalta = false;
      this.showpassaltarepita = false;
      this.cambiarcontrasena = false;
    },
    aceptaralta() {
      API.Beneficiarios.ModificarDatosContacto(this.beneficiarioregistro);
      if (!this.cambiarcontrasena) {
        API.UsuariosBeneficiarios.alta({
          id_afiliado: this.beneficiarioregistro.id_afiliado,
          password: this.contrasenaalta,
        });
      } else {
        API.UsuariosBeneficiarios.modificar({
          id_afiliado: this.beneficiarioregistro.id_afiliado,
          password: this.contrasenaalta,
        });
      }
      this.resetear();
    },
    recuperarcontrasena() {
      API.UsuariosBeneficiarios.recuperarcontrasena(this.mailrecuperar);
    },
    async login() {
      if (this.dni !== "") {
        await this.loguear({ dni: this.dni, contrasena: this.contrasena });
        if (this.Usuario) {
          let ben = await API.Beneficiarios.traerPorDNI(this.dni);
          if (this.contrasena == "12345") {
            this.beneficiarioregistro = ben[0];
            this.cambiarcontrasena = true;
            this.tab = 1;
          }
          //this.setNuevo(ben[0]);
          //this.selectTitular(ben[0]);
          else {
            this.select(ben[0]);
            if (ben[0].parent == 0) {
              this.$emit("titularlogueado");
            } else {
              this.$emit("familiarlogueado");
            }
            await this.inicializar();
            this.cargarData();
            this.traerUserId();
            this.$router.push({ name: 'PracticasAutogestion'});
          }
        }
      } else {
        alert("Ingrese un dni valido");
      }
    },
    async validar() {
      if (this.dni !== "" && this.fec_nac) {
        this.beneficiarioregistro = await API.Beneficiarios.Validar(
          this.dni,
          this.fec_nac
        );
      }
    },
  },
  created() {
    this.logout();
  },
};
</script>
